'use memo'

import { VendorBankDetailsStatuses } from '@urbanx/agx.campaigns.client'
import { AgxBadge } from '@urbanx/agx.ui-components2'
import type { BadgeColor } from '@urbanx/agx.ui-components2'
import dayjs from 'dayjs'

export const formatVendorBankDetails = (
  vendorBankDetails?: VendorBankDetailsStatuses
) => {
  switch (vendorBankDetails) {
    case VendorBankDetailsStatuses.Complete: {
      return (
        <AgxBadge
          type="colourfill"
          variant="normal"
          size="md"
          text="Complete"
          colour="green"
        />
      )
    }
    case VendorBankDetailsStatuses.Outstanding: {
      return (
        <AgxBadge
          type="colourfill"
          variant="normal"
          size="md"
          text="Outstanding"
          colour="red"
        />
      )
    }
    default: {
      return (
        <AgxBadge
          type="colourfill"
          variant="normal"
          size="md"
          text="N/A"
          colour="grey"
        />
      )
    }
  }
}

export const formatSettlementDateBadge = (date?: Date | string, status?: string) => {
  if (!date) {
    return (
      <AgxBadge
        type="colourfill"
        variant="normal"
        size="md"
        text="Settle not set"
        colour={
          status && status.toLowerCase() === 'terminated' ? 'grey' : 'yellow'
        }
      />
    )
  }

  const settlementDate = dayjs(date)
  const settlementDateToday = settlementDate.isSame(dayjs(), 'day')
  const isSettled = settlementDate.isBefore(dayjs(), 'day')

  if (settlementDateToday) {
    return (
      <AgxBadge
        type="highlighted"
        variant="normal"
        size="md"
        highlightText="Today"
        text={`${settlementDate.format('Do MMM')}`}
        colour={
          status && status.toLowerCase() === 'terminated' ? 'grey' : 'yellow'
        }
      />
    )
  }

  return (
    <AgxBadge
      type="colourfill"
      variant="normal"
      size="md"
      text={`${isSettled ? 'Settled' : ''} ${settlementDate.format('Do MMM')}`}
      colour={
        status && (status.toLowerCase() === 'terminated' || isSettled)
          ? 'grey'
          : 'yellow'
      }
    />
  )
}

export const statusBadgeColor = (status?: string): BadgeColor => {
  if (!status) return 'grey'

  switch (status.toLowerCase()) {
    case 'awaiting exchange':
      return 'blue'
    case 'accepted':
      return 'yellow'
    case 'unconditional':
      return 'teal'
    case 'conditional':
      return 'orange'
    case 'settled':
      return 'green'
    case 'back up':
      return 'purple'
    case 'terminated':
      return 'grey'
    case 'pending compliance':
      return 'purple'
    default:
      return 'grey'
  }
}
